(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.html',
    '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.js